<template>
    <div>
        <div v-if="$store.getters.currentWidth > 768">
            <div class="home-box1">
              <div class="home-box2">
                <el-row>
                  <el-col :span="12" style="align-items: center; justify-content: center; height: 100%;">
                    <div class="grid-content" style="padding-top: 80px;padding-left: 20%">
                      <div class="ipad-container">
                        <!-- iPad 边框 -->
                        <div class="ipad-frame">
                          <!-- 视频内容 -->
                          <video
                              autoplay
                              muted
                              loop
                              playsinline
                              controls
                              controlslist="nodownload"
                              style="width: 100%; height: 100%; object-fit: cover; border-radius: 10px;"
                          >
                            <source src="~@/assets/images/home.mp4" type="video/mp4">
                          </video>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="align-items: center; justify-content: center; height: 100%;">
                    <div class="grid-content" style="padding-top: 20%;padding-left: 20%">
                      <div class="home-box2-text2">
                        <div style="font-size: 3rem; font-weight: bold; margin-bottom: 2rem">{{ $t("home.slogan0") }}</div>
                        <div style="font-size: 3rem; font-weight: bold; margin-bottom: 2rem">{{ $t("home.slogan1") }}</div>
                        <div style="margin-bottom: 1.5rem">{{ $t("home.describe1") }}</div>
                        <div>
                          <!--                            <span class="el-icon-caret-right"></span>-->
                          <!--                            <span>{{ $t("home.watch") }}</span>-->
                          <button class="cursor-pointer" @click="onSubscribe" style="background: #fcc03a; box-shadow: 0px 0.25rem 0 #c28c00; border: none; border-radius: 2rem; padding: 0.875rem 1.75rem">
                            {{ $t("other.order") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>

<!--                <div style="display: flex; align-items: center; position: absolute; bottom: 6.5rem; left: 2.5rem">-->
<!--                  <img src="@/assets/images/wavy.png" style="width: 0.625rem; margin-right: 1rem" />-->
<!--&lt;!&ndash;                  <div style="white-space: pre-wrap; font-size: 18px; line-height: 32px; color: #fff">{{ "向下移動\n了解更多" }}</div>&ndash;&gt;-->
<!--                </div>-->
              </div>
            </div>
            <div class="home-box4">
                <img src="@/assets/images/bear.png" style="right: 0; position: absolute; width: 16vw; margin-top: -20vw" />
                <div class="home-box3-text">
                    <div style="font-size: 2rem; font-weight: bold; margin-bottom: 1rem">{{ $t("home.slogan2") }}</div>
                    <div style="text-align: left;font-size: 18px; line-height: 28px" :style="{ width: $store.getters.language == languageZhTc ? '44.5rem' : '50rem' }">{{ $t("home.describe2") }}</div>
                </div>
                <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
                    <div v-for="(item, index) in characteristic" :key="index" style="color: white; text-align: center; padding: 1.125rem">
                        <img style="width: 5rem; max-width: 5rem; min-width: 5rem; margin: 0 3vw" :src="require(`@/assets/images/home-group${index + 1}.png`)" />
                        <div>{{ $store.getters.language == languageZhTc ? item.zh : item.en }}</div>
                    </div>
                </div>
                <div style="text-align: center; width: 100%; margin-top: 4.375rem; padding-bottom: 6rem">
                    <button class="cursor-pointer" @click="onSubscribe" style="background: #fcc03a; box-shadow: 0px 0.25rem 0 #c28c00; border: none; border-radius: 2rem; padding: 0.875rem 1.75rem">
                      {{ $t("other.order") }}
                    </button>
                </div>
                <div style="position: absolute; bottom: 0; margin-bottom: -6vw; left: 1vw">
                    <img src="@/assets/images/home-group6.png" style="width: 16vw; height: 14vw" />
                </div>
            </div>
        </div>
        <div v-else>
            <div class="home-box1" style="padding-top: 21.75rem">
              <!-- 视频背景 -->
              <div class="ipad-container bg-video-min">
                <!-- iPad 边框 -->
                <div class="ipad-frame">
                  <!-- 视频内容 -->
                  <video
                      autoplay
                      muted
                      loop
                      playsinline
                      controls
                      controlslist="nodownload"
                      style="width: 100%; height: 100%; object-fit: cover; border-radius: 10px;"
                  >
                    <source src="~@/assets/images/home.mp4" type="video/mp4">
                  </video>
                </div>
              </div>
<!--                <div class="home-box2"></div>-->
<!--                <div style="display: flex; align-items: center; position: absolute; bottom: 8.1875rem; left: 1rem">-->
<!--                    <img src="@/assets/images/wavy.png" style="width: 0.5rem; margin-right: 1rem" />-->
<!--&lt;!&ndash;                    <div style="white-space: pre-wrap; line-height: 26px; color: #fff">{{ "向下移動\n了解更多" }}</div>&ndash;&gt;-->
<!--                </div>-->
            </div>
            <div class="home-box3">
                <div class="home-box3-text" style="padding-top: 3rem">
                  <div style="font-size: 2rem; font-weight: bold">{{ $t("home.slogan0") }}</div>
                    <div style="font-size: 2rem; font-weight: bold">{{ $t("home.slogan1") }}</div>
                    <div style="margin: 2rem 0">{{ $t("home.describe1") }}</div>
                    <div>
<!--                        <span class="el-icon-caret-right"></span>-->
<!--                        <span>{{ $t("home.watch") }}</span>-->
                      <button class="cursor-pointer" @click="onSubscribe" style="background: #fcc03a; box-shadow: 0px 0.25rem 0 #c28c00; border: none; border-radius: 2rem; padding: 0.875rem 1.75rem">
                        {{ $t("other.order") }}
                      </button>
                    </div>
                </div>
                <img src="@/assets/images/bear.png" style="right: 0; position: absolute; height: 12.5rem; margin-top: -8rem" />
                <div class="home-box3-text" style="margin-top: 0rem">
                    <div style="font-size: 1.2rem; font-weight: bold; margin-bottom: 1.5rem">{{ $t("home.slogan2") }}</div>
                    <div style="line-height: 1.5;">{{ $t("home.describe2") }}</div>
                </div>
                <div style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
                    <div v-for="(item, index) in characteristic" :key="index" style="color: white; text-align: center; margin: 2rem 0.75rem">
                        <img style="width: 20vw; max-width: 20vw; min-width: 20vw; margin-bottom: 1rem" :src="require(`@/assets/images/home-group${index + 1}.png`)" />
                        <div>{{ $store.getters.language == languageZhTc ? item.zh : item.en }}</div>
                    </div>
                </div>
                <div style="text-align: center; bottom: 12%; width: 100%; margin-top: 3.375rem">
                    <button class="cursor-pointer" @click="onSubscribe" style="background: #fcc03a; box-shadow: 0px 0.25rem 0 #c28c00; border: none; border-radius: 2rem; padding: 0.875rem 1.75rem">
                        {{ $t("other.order") }}
                    </button>
                </div>
                <div style="position: absolute; bottom: -13vw; left: 2vw">
                    <img src="@/assets/images/home-group6.png" style="width: 30vw; height: 28vw" />
                </div>
            </div>
        </div>

        <div :style="{ marginTop: $store.getters.isPC ? '7.5rem' : '5.375rem' }" style="text-align: center; display: flex; flex-direction: column; align-items: center">
            <div style="font-weight: bold; font-size: 1.5rem">{{ $t("home.slogan3") }}</div>
            <div :style="{ margin: $store.getters.isPC ? '2rem' : '0.5rem' }" style="text-align: left;max-width: 44.5rem; font-size: 18px; line-height: 1.5">
                {{ $t("home.describe3") }}
            </div>

            <carousel v-if="$store.getters.currentWidth > 768" style="width: 86vw" :banner="banner">

            </carousel>

            <el-carousel
                v-if="$store.getters.currentWidth <= 768"
                arrow="never"
                indicator-position="none"
                @change="changeItem"
                :height="bannerHeight + 'px'"
                ref="banner"
                style="padding: 3rem 1rem 0; width: 100%"
            >
                <el-carousel-item v-for="(item, index) in banner" :key="index">
                    <div ref="bannerHeight">
                        <div style="font-weight: bold; font-size: 1.25rem">{{ $store.getters.language == languageZhTc ? item.title : item.label }}</div>
                        <p style="margin: 1rem 0; line-height: 1.5">
                            {{ item.title=='冒險模式'?$t("home.banner1"):$t("home.banner2") }}
                        </p>
                        <img @load="imgLoad" :src="item.image" style="width: 100%; height: 12.5rem; border-radius: 30px;" />
                    </div>
                </el-carousel-item>
            </el-carousel>
            <div v-if="$store.getters.currentWidth <= 768" style="color: white; display: flex; justify-content: space-evenly; width: 100%; margin-top: 0.375rem">
                <span class="el-icon-back cursor-pointer" @click="carouselPrevious"></span>
                <span class="el-icon-right cursor-pointer" @click="carouselNext"></span>
            </div>
        </div>

        <div class="home-grades-bg" style="text-align: end">
            <img src="@/assets/images/home-group7.png" style="right: 0; position: absolute; top: -1rem" :style="{ top: $store.getters.currentWidth > 768 ? '-1rem' : '-3rem' }" />
            <div style="text-align: center; color: white; font-size: 1.625rem">{{ directory.title }}</div>
            <div style="display: flex;flex-direction: column;align-items: center;padding: 0.5rem;text-align: center;">
              <div :style="{ margin: $store.getters.isPC ? '2rem' : '0.5rem' }" style="text-align: left;color: white;max-width: 44.5rem; font-size: 18px; line-height: 1.5">
                {{ $t("home.describe4") }}
              </div>
            </div>
            <el-row v-if="$store.getters.currentWidth > 768" justify="space-around" type="flex" :gutter="50" style="flex-wrap: wrap; width: 80%; margin: auto">
                <el-col v-for="(item, index) in directory.topic" :key="index" :span="8" style="text-align: center; min-width: 20rem; margin-top: 2rem">
                    <div style="position: relative; right: 40%">
                        <img src="@/assets/images/flag.png" style="vertical-align: middle; height: 4.5rem" />
                        <span style="position: absolute; top: 22%; left: 48%; font-weight: bold; color: white">{{ index + 1 }}</span>
                    </div>
                    <div class="grades-box">
                        <div class="grades-box-title">{{ item.label }}</div>
                        <div class="grades-box-list" v-for="(item2, index2) in item.value" :key="index2">
                            <div class="grades-box-list-text">{{ item2 }}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-carousel v-else arrow="never" indicator-position="none" @change="changeItem2" :height="bannerHeight3 + 'px'" ref="grades" style="width: 80%; margin: auto; margin-top: 2rem">
                <el-carousel-item v-for="(item, index) in directory.topic" :key="index" style="text-align: center">
                    <div ref="bannerHeight3">
                        <div style="position: relative; right: 30%">
                            <img src="@/assets/images/flag.png" style="vertical-align: middle" />
                            <span style="position: absolute; top: 22%; left: 48%; font-weight: bold; color: white">{{ index + 1 }}</span>
                        </div>
                        <div class="grades-box">
                            <div class="grades-box-title">{{ item.label }}</div>
                            <div class="grades-box-list" v-for="(item2, index2) in item.value" :key="index2">
                                <div class="grades-box-list-text">{{ item2 }}</div>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <div v-if="$store.getters.currentWidth <= 768" style="color: white; display: flex; justify-content: space-evenly; margin-top: 2rem">
                <span class="el-icon-back cursor-pointer" @click="gradesPrevious"></span>
                <span class="el-icon-right cursor-pointer" @click="gradesNext"></span>
            </div>
        </div>

        <div style="background-color: white; padding: 3rem 1.25rem">
            <div style="text-align: center; font-size: 2rem; font-weight: bold;">{{ $t("home.process") }}</div>
            <div style="display: flex;flex-direction: column;align-items: center;padding: 0.5rem;text-align: center;">
              <div :style="{ margin: $store.getters.isPC ? '2rem' : '0.5rem' }" style="text-align: left;max-width: 44.5rem; font-size: 18px; line-height: 1.5">
                {{ $t("home.describe5") }}
              </div>
            </div>
            <div style="overflow: auto" v-if="$store.getters.isPC">
                <div style="display: flex; flex-direction: column; align-items: center; width: 1040px; margin: auto">
                    <div style="display: flex">
                        <div v-for="(item, index) in step" :key="index" style="display: flex; align-items: center">
                          <img style="width: 6.5rem; height: 6.5rem;border-radius: 15px;box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);" :src="item.image" />
                          <img v-if="index < step.length - 1" style="width: 6.5rem" src="@/assets/images/footprint1.png" />
                        </div>
                    </div>
                    <div style="display: flex; width: 65rem">
                        <div v-for="(item, index) in step" :key="index" style="margin: 0 18px; width: 180px; word-break: break-all">
                            <div style="text-align: center; font-weight: bold; margin: 0.5rem 0; font-size: 20px">{{ item.title }}</div>
                            <div style="text-align: center; font-weight: bold; margin: 0.5rem 0; font-size: 20px">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else v-for="(item, index) in step" :key="index" style="text-align: center; word-break: break-all">
              <img style="width: 10.5rem; height: 10.5rem;border-radius: 15px;box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);" :src="item.image" />
                <div style="text-align: center; font-weight: bold; margin: 0.5rem 0; font-size: 18px">{{ item.title }}</div>
                <div style="line-height: 26px">{{ item.content }}</div>
                <img v-if="index < step.length - 1" style="height: 100%; height: 2.5rem; margin: 2rem 0 1rem" src="@/assets/images/footprint2.png" />
            </div>
        </div>

        <div style="color: white; text-align: center;width: 100%;background-color: #b62d2e;" class="join">
            <div v-if="$store.getters.currentWidth <= 768" style="color: white;font-size: 6vw; font-weight: bold; padding-bottom: 4vw; padding-top: 20vw; white-space: pre-wrap">
                {{ $store.getters.language == languageZhTc ?"立即聯絡" : "Contact Us!" }}
            </div>
          <div v-if="$store.getters.currentWidth <= 768" style="color: white;font-size: 5vw; font-weight: bold; padding-bottom: 0vw; padding-top: 0vw; white-space: pre-wrap">
            {{ $store.getters.language == languageZhTc ?"MathConcept Online!" : "" }}
          </div>
            <div v-if="$store.getters.currentWidth > 768" style="color: white;font-size: 2vw; font-weight: bold; padding-bottom: 1vw; padding-top: 10vw">
                {{ $store.getters.language == languageZhTc ? "立即聯絡 MathConcept Online" : "Contact Us!" }}
            </div>
          <div v-if="$store.getters.currentWidth > 768" style="display: flex;flex-direction: column;align-items: center;padding: 0.5rem;text-align: center;">
            <div style="color: white;max-width: 30rem; font-size: 18px; line-height: 1.5;text-align: left">
              <br>
              {{ $t("home.describe6") }}
            </div>
          </div>
          <div v-if="$store.getters.currentWidth <= 768" style="display: flex;flex-direction: column;align-items: center;padding: 0.5rem;text-align: center;">
            <div style="margin:0.5rem;color: white;max-width: 30rem; font-size: 18px; line-height: 1.5;text-align: left">
              <br>
              {{ $t("home.describe6") }}
            </div>
          </div>
          <div style="display: flex;flex-direction: column;align-items: center;padding: 0.5rem;text-align: center;">
            <div :style="{ margin: $store.getters.isPC ? '2rem' : '0.5rem' }" style="text-align: center;max-width: 44.5rem; font-size: 18px; line-height: 28px">
              <button
                  class="cursor-pointer"
                  @click="onSubscribe"
                  style="font-size: 18px;background: #fcc03a; box-shadow: 0px 0.25rem 0 #c28c00; border: none; border-radius: 1rem; padding: 0.375rem 1.25rem;"
              >
                {{ $t("other.order") }}
              </button>
            </div>
          </div>
          <p style="height: 100px;"></p>
        </div>

    </div>
</template>

<script>
// import {getBanners} from '@/api/setting'
import { directory } from "@/biz/static-data";
import carousel from "@/components/carousel";
import { isPC, isPad } from "@/utils/is-rules";
export default {
    name: "home",
    components: { carousel },
    data() {
        return {
            tabIndex: 0,
            tabIndex2: 0, //年级
            bannerHeight: null,
            bannerHeight2: null, //第二张
            bannerHeight3: null, //年级
            characteristic: [
                {
                    zh: "特點",
                    en: "Characteristics",
                },
                {
                    zh: "個性化學習計劃",
                    en: "Personalized learning plan",
                },
                {
                    zh: "動畫短片",
                    en: "Animated short film",
                },
                {
                    zh: "數學題庫",
                    en: "Mathematics question bank",
                },
                {
                    zh: "成長軌跡",
                    en: "Growth Trajectory",
                },
            ],
          step: [
            {
              title: this.$i18n.t('step.step1Title'),
              content: this.$i18n.t('step.step1Content'),
              image: require(`@/assets/images/step1.png`)
            },
            {
              title: this.$i18n.t('step.step2Title'),
              content: this.$i18n.t('step.step2Content'),
              image: require(`@/assets/images/step2.png`)
            },
            {
              title: this.$i18n.t('step.step3Title'),
              content: this.$i18n.t('step.step3Content'),
              image: require(`@/assets/images/step3.png`)
            },
            {
              title: this.$i18n.t('step.step4Title'),
              content: this.$i18n.t('step.step4Content'),
              image: require(`@/assets/images/step4.png`)
            },
            {
              title: this.$i18n.t('step.step5Title'),
              content: this.$i18n.t('step.step5Content'),
              image: require(`@/assets/images/step5.png`)
            },
          ],
            directory: {},
        };
    },
    watch: {
        "$store.getters.language": {
            handler(v) {
                this.$nextTick(() => {
                    this.directory = directory[v];
                });
            },
            deep: true,
        },
    },

    mounted() {
        this.directory = directory[this.$store.getters.language];
        this.$store.dispatch("setWidth", window.innerWidth);
        window.onresize = () => {
            return (() => {
                this.$store.dispatch("setWidth", window.innerWidth);
                this.$store.dispatch("setIsPC", isPC());
                this.$store.dispatch("setIsPad", isPad());
                if (window.innerWidth <= 768) this.imgLoad();
            })();
        };
    },
    created() {
        this.initial();
    },
    destroyed() {
        window.onresize = null;
    },
    methods: {
        changeItem(e) {
            this.tabIndex = e;
            //this.bannerHeight = this.$refs.bannerHeight[this.tabIndex].offsetHeight
        },
        changeItem2(e) {
            this.tabIndex2 = e;
            this.bannerHeight3 = this.$refs.bannerHeight3[this.tabIndex2].offsetHeight;
        },
        imgLoad() {
            this.$nextTick(() => {
                this.bannerHeight = this.$refs.bannerHeight[this.tabIndex].offsetHeight;
                //  if(this.$store.getters.isPC){
                //   this.bannerHeight2 = this.tabIndex < this.banner.length-1 ?this.$refs.bannerHeight2[this.tabIndex+1].offsetHeight:this.$refs.bannerHeight2[0].offsetHeight
                //   }
                // else {
                //   this.bannerHeight3 = this.$refs.bannerHeight3[this.tabIndex2].offsetHeight
                // }
            });
            this.$forceUpdate();
        },
        onShowMore() {
            this.$router.push({ path: `/programme` });
        },
        onLearnMore(id) {
            this.$router.push({ path: `/programme/${id}` });
        },
        initial() {
            this.getBanners();
        },
        getBanners() {
            // getBanners().then((v)=>{
            //    this.banner  = v.data
            // })
            let arr = [
                { title: "冒險模式", label: "Adventure Mode", image: require(`@/assets/images/banner1.png`) },
                { title: "圖書館模式", label: "Library Mode", image: require(`@/assets/images/banner2.png`) },
            ];
            this.banner = arr;
        },
        //轮播图上一张
        carouselPrevious() {
            this.$refs.banner.prev();
        },
        //轮播图下一张
        carouselNext() {
            this.$refs.banner.next();
            if (this.$store.getters.isPC) {
                this.$refs.banner2.next();
            }
        },
        //年级目录上一张
        gradesPrevious() {
            this.$refs.grades.prev();
        },
        //年级目录下一张
        gradesNext() {
            this.$refs.grades.next();
        },
        onSubscribe() {
            if (this.userInfo.roleName != this.roleNameStudent) this.$router.push({ name: "cart" });
        },
    },
};
</script>

<style lang="scss" scoped>
.ipad-container {
  /* 控制整体大小，可根据需要调整 */
  width: 100%;
/*  max-width: 720px;*/
  margin: 0 auto; /* 居中显示 */
}

.ipad-frame {
  /* iPad 边框样式 */
  border: 16px solid #1a1a1a; /* 边框颜色 */
  border-radius: 40px; /* 设备圆角 */
  position: relative;
  padding: 20px 10px; /* 上下留更多空间模拟屏幕黑边 */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3); /* 加个阴影更真实 */
  background-color: white;
}

/* 底部Home键 */
.ipad-frame::after {
  content: '';
  position: absolute;
  bottom: -18px; /* 超出边框一点 */
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #333;
  background-color: #f0f0f0;
}
@font-face {
    font-display: swap;
    font-family: "AsyncGif";
    src: url("~@/assets/images/home.gif") format("truetype");
    font-weight: normal;
    font-style: normal;
}
.home-box1 {
    position: relative;
    //background: url("~@/assets/images/home.gif") center center/cover no-repeat;
}
.bg-video {
  position: absolute;
  top: 80px;
  left: 80px;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持视频比例并覆盖整个容器 */
  z-index: 999999; /* 放置在内容下方 */
}
.bg-video-min {
  position: absolute;
  top: 5px;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持视频比例并覆盖整个容器 */
  z-index: 9; /* 放置在内容下方 */
}
.home-box2 {
    position: relative;
    background-image: url("~@/assets/images/home-bg1.png");
    background-repeat: no-repeat;
    background-size: 110% 100%;
    height: 100%;
  padding-bottom: 60px;
    //height: calc(100vh - 4.5rem);
}
.home-box2-text {
    position: relative;
    color: white;
    margin-left: 58%;
    top: 34%;
}
.home-box2-text2 {
  position: relative;
  color: white;
}
.home-box3 {
    position: relative;
    background-image: url("~@/assets/images/home-bg2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    min-height: 70rem;
    padding-bottom: 5rem;
    margin-top: -1px;
}
.home-box3-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    padding: 2.5rem;
    text-align: center;
}
.home-box4 {
    position: relative;
    background-image: url("~@/assets/images/home-bg3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    //height: 37.5rem;
}
.home-grades-bg {
    position: relative;
    background: url("~@/assets/images/grades-bg1.png") center 100% / cover no-repeat;
    margin-top: 5rem;
    padding: 5rem 0.25rem;
}
.home-box {
    padding: 3.75rem 8.75rem;
}
.grades-box {
    background-color: white;
    border-radius: 1rem;
    padding: 2rem;
    height: calc(100% - 4rem);
    .grades-box-title {
        font-size: 1.625rem;
        font-weight: bold;
        margin-bottom: 1rem;
    }
    .grades-box-list {
        text-align: left;
        line-height: 1.625rem;
        width: 80%;
        margin: auto;
        &::before {
            content: " ";
            background: black;
            border-radius: 50%;
            width: 0.25rem;
            height: 0.25rem;
            margin-top: 0.625rem;
            position: absolute;
        }
        .grades-box-list-text {
            padding-left: 0.5rem;
            font-family: "GenSenRoundedJP", "Helvetica", "Arial";
        }
    }
}
[class^="el-icon-"] {
    background: #fcc03a;
    box-shadow: 0px 0.25rem 0 #c28c00;
    border: none;
    border-radius: 50%;
    font-size: 1.625rem;
    font-weight: bold;
    padding: 0.25rem;
}
.el-icon-caret-right {
    vertical-align: sub;
    margin-right: 0.5rem;
}
.join {
    background-image: url("~@/assets/images/join-bg1.jpg");
    background-repeat: no-repeat;
    background-size: 100%;

}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: $minWidth) and (max-width: $maxWidth) {
    .home-box {
        padding: 2.75rem 6.75rem;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .home-box {
        padding: 1.25rem;
    }
    .home-box1 {
        //background: url("~@/assets/images/home.gif") 40% center/cover no-repeat;
        height: 24.35rem;
        margin-bottom: -5.6875rem;
    }
    .home-box2 {
        background-image: url("~@/assets/images/home-bg4.png");
        background-repeat: no-repeat;
        background-size: 110% 100%;
        height: 13.25rem;
    }
    //.grades-box{
    //  margin-bottom: 17.25rem;
    //}
    .home-grades-bg {
        background: url("~@/assets/images/grades-bg2.png") center 100% / cover no-repeat;
        //margin-top:5rem;
        //padding:5rem 1.25rem;
    }
    .join {
        background-image: url("~@/assets/images/join-bg2.jpg");
        background-repeat: no-repeat;
        background-size: cover;
      background-size: 100%;
        //background-color: #B62D2E;
    }
}
</style>
